/**
 * Состав пака «step-form» (WEB-3718) — смысл групп и источник каждого числа:
 * `../stylePackComposition.ts`. Файл на пак, общий список `./index.ts`
 * собирается по каталогу (решение владельца 23.10 ~04:35).
 */
import type { StylePackComposition } from '../stylePack.types';

export const composition: StylePackComposition = {
  // 22 воронок: группы.json, группы 15 (PACK в matrix.py)
  palettes: [
    // 4 из 22 воронок: palette → ближайшая тема по цветам
    { themeId: 'ink-premium', weight: 0.18 },
    // 3 из 22 воронок: palette → ближайшая тема по цветам
    { themeId: 'cream-editorial', weight: 0.14 },
    // 3 из 22 воронок: palette → ближайшая тема по цветам
    { themeId: 'blue-gradient-light', weight: 0.14 },
  ],
  fonts: [
    // 18 из 22 воронок: fontId
    { fontId: 'inter', weight: 0.82 },
  ],
  screenKinds: [
    // средняя доля экранов по 22 воронкам (признаки.json kinds) 0.428; сюда свёрнуты Q10, Q6 (замена из arsenal.mjs)
    { kind: 'Q1', share: 0.51 },
    // средняя доля экранов по 22 воронкам (признаки.json kinds) 0.086
    { kind: 'N1', share: 0.1 },
    // средняя доля экранов по 22 воронкам (признаки.json kinds) 0.070
    { kind: 'Q8', share: 0.08 },
    // средняя доля экранов по 22 воронкам (признаки.json kinds) 0.060; сюда свёрнуты Q3 (замена из arsenal.mjs)
    { kind: 'Q2', share: 0.07 },
    // средняя доля экранов по 22 воронкам (признаки.json kinds) 0.055; сюда свёрнуты Q7 (замена из arsenal.mjs)
    { kind: 'Q5', share: 0.06 },
    // средняя доля экранов по 22 воронкам (признаки.json kinds) 0.050
    { kind: 'I1', share: 0.06 },
    // средняя доля экранов по 22 воронкам (признаки.json kinds) 0.050
    { kind: 'N5', share: 0.06 },
    // средняя доля экранов по 22 воронкам (признаки.json kinds) 0.045
    { kind: 'Q12', share: 0.05 },
  ],
  blocks: [
    // в 20 из 22 воронок (признаки.json blocks), подъём 2.02
    { type: 'multiple_choice', weight: 0.91, settings: {} },
    // в 22 из 22 воронок (признаки.json blocks), подъём 1.46; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 403 из 458, optionIndicator 359 из 458
    {
      type: 'single_choice',
      weight: 1.0,
      settings: { autoAdvance: true, optionIndicator: 'none' },
    },
    // в 14 из 22 воронок (признаки.json blocks), подъём 2.82; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): autoAdvance 16 из 19
    { type: 'image_choice', weight: 0.64, settings: { autoAdvance: true } },
    // в 10 из 22 воронок (признаки.json blocks), подъём 3.18; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): testimonialQuoteMarks 45 из 55
    {
      type: 'testimonials',
      weight: 0.45,
      settings: { testimonialQuoteMarks: true },
    },
    // в 6 из 22 воронок (признаки.json blocks), подъём 5.21
    { type: 'preference_card', weight: 0.27, settings: {} },
    // в 12 из 22 воронок (признаки.json blocks), подъём 1.36
    { type: 'email', weight: 0.55, settings: {} },
    // в 7 из 22 воронок (признаки.json blocks), подъём 2.08; настройки — большинство в собранных воронках (out/_packs2/all/*/converted): unitPickerLook 9 из 15, unitToggleLook 8 из 15, unitTogglePosition 8 из 15
    {
      type: 'weight_picker',
      weight: 0.32,
      settings: {
        unitPickerLook: 'big-number',
        unitToggleLook: 'pill',
        unitTogglePosition: 'above',
      },
    },
  ],
  niches: [
    // 5 из 22 воронок (признаки.json theme)
    { niche: 'education', weight: 0.23 },
    // 3 из 22 воронок (признаки.json theme)
    { niche: 'nutrition', weight: 0.14 },
    // 2 из 22 воронок (признаки.json theme)
    { niche: 'weight_loss', weight: 0.09 },
    // 2 из 22 воронок (признаки.json theme)
    { niche: 'fitness', weight: 0.09 },
  ],
};
